module.exports = __webpack_public_path__ + "static/media/41.bed07ad6.mp3";